module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_comida-fit.73f7254a.png";